export const PARENT_TASKS_COLUMN_HEADER = 'parent_wf_header_title';
export const RELATED_REQUESTS_COLUMN_HEADER = 'related_requests_header_title';

export const COLUMN_IDENTIFIERS = {
  NUMBER: 'number',
  ID: 'id',
  NAME: 'name',
  PARENT_TASKS: 'parent_tasks',
  RELATED_REQUESTS: 'related_requests',
  CREATION_DATE: 'creation_date',
  ASSIGNEES: 'assignees',
  CREATOR: 'creator',
  SLA: 'sla',
  REMAINING_TIME: 'remaining_time',
  REQUEST_SUBJECT: 'request_subject',
  PROJECT: 'project',
  CURRENT_STEP: 'current_step',
  STATUS: 'status',
  ACTION: 'action',
} as const;